export default __webpack_public_path__ + "static/media/Feldenkrais.e81f4220.jpg";